import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const CAMPAIGN_STORAGE_KEY = 'lidea.campaign';

type CampaignState = {
  campaignId: number | null;
  setCampaignId: (campaignId: number) => void;
  clearCampaignId: () => void;
};

export const useCampaignStore = create<CampaignState>()(
  persist(
    (set) => ({
      campaignId: null,
      setCampaignId: (campaignId) => set({ campaignId }),
      clearCampaignId: () => set({ campaignId: null }),
    }),
    { name: CAMPAIGN_STORAGE_KEY }
  )
);

export const getCampaignId = () => useCampaignStore.getState().campaignId;

export default useCampaignStore;
